import { render, staticRenderFns } from "./UserAccessPreview.vue?vue&type=template&id=b50dc6ec&scoped=true"
import script from "./UserAccessPreview.vue?vue&type=script&lang=js"
export * from "./UserAccessPreview.vue?vue&type=script&lang=js"
import style0 from "./UserAccessPreview.vue?vue&type=style&index=0&id=b50dc6ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50dc6ec",
  null
  
)

export default component.exports